/**
 * Home component
 *
 * The section at the top of the page to display image of your
 * choice, name and title that describes your career focus.
 */

import React from "react";
import arrowSvg from "url:../images/down-arrow.svg";
import PropTypes from "prop-types";

/**
 * Home background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import imageUrl from "url:../images/DosomethingGreat_unsplash.jpg";

const imageAltText = "A sign that says 'Do Something Great'";

const Home = ({ name = "", title = "" }) => {
  return (
    <section id="home" className="min-height">
      <img className="background home-background" src={imageUrl} alt={imageAltText} />
      <div
        style={{
          position: "absolute",
          top: "5rem",
          left: "2rem",
          width: "17rem",
          color: "white",
          textShadow: "0 2px 10px rgba(0, 0, 0, 0.55)",
        }}
      >
        <h1>{name}</h1>
        <h2>{title}</h2>
      </div>
      <div style={{ position: "absolute", bottom: "3rem", left: "50%" }}>
        <img src={arrowSvg} className="bounce-arrow" style={{ height: "3rem", width: "3rem" }} alt={imageAltText} />
      </div>
    </section>
  );
};

Home.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
};

export default Home;
